import jQuery from "jquery";
import {ZIDX} from "./standaloneLibrary.js";

let $=jQuery.noConflict();

// you probably don't change the classes
export class AnimateOnScrollOptions{
    debug:boolean=false;
    scrollSelector:string='';
    callbackFunction:Function=function(this:HTMLElement, scrollPercent:number){ console.log("scrollPercent", scrollPercent, "for", this); };
    constructor(){
    }
}

export class AnimateOnScroll{
    options:AnimateOnScrollOptions;
    scrollElements:JQuery;
    arrScrollElements:HTMLElement[]=[];
    zidx:ZIDX;
    constructor(props:AnimateOnScrollOptions, zidx:ZIDX) {
        this.zidx=zidx;
        this.options=props;
        let self=this;
        this.scrollElements=$(this.options.scrollSelector, this.zidx.peakidxShadowRoot);
        this.scrollElements.each(function (this: HTMLElement) {
            self.arrScrollElements.push(this);
        });
        $(window).on("scroll wheel", function(){
            self.update();
        });
        $(window).on("clientresize resize", function(){
            self.update();
        });
        this.update();
    }
    update(){
        for(let i=0;i<this.arrScrollElements.length;i++){
            let scrollElement=this.arrScrollElements[i];
            let position:DOMRect=scrollElement.getBoundingClientRect();
            let topPosition=(window.scrollY+window.innerHeight)-scrollElement.offsetTop;
            let bottomPosition=(window.scrollY)-(scrollElement.offsetTop+position.height);
            let scrollPercent=0;
            if(topPosition>0){
                if(bottomPosition<0) {
                    scrollPercent=topPosition/(position.height+window.innerHeight);
                }else{
                    scrollPercent=1;
                }
            }else{
                scrollPercent=0;
            }
            this.options.callbackFunction(scrollElement, scrollPercent);
        }
    }
}